<template>
  <router-view />
  <Footer />
</template>

<script>
import Footer from "@/components/common/Footer.vue";
export default {
  name: "MainLayout",
  components: {
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/reset.css";
@import "@/assets/css/glyphicon.css";
@import "@/assets/css/ntax.css";
@import "@/assets/css/ntaxAPI.css";
@import "@/assets/css/font_eval_m.css";
@import "@/assets/css/font-awesome.css";

a {
  cursor: pointer;
}
</style>